import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Routes, CanActivate } from '@angular/router';

import { UserRouteAccessService } from '../../shared';
import { PaginationUtil } from 'ng-jhipster';

import { ApplicationArtatechComponent } from './application-artatech.component';
import { ApplicationArtatechDetailComponent } from './application-artatech-detail.component';
import { ApplicationArtatechPopupComponent } from './application-artatech-dialog.component';
import { ApplicationArtatechDeletePopupComponent } from './application-artatech-delete-dialog.component';

import { Principal } from '../../shared';


export const applicationRoute: Routes = [
  {
    path: 'application-artatech',
    component: ApplicationArtatechComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'deviceConfigurerServiceApp.application.home.title'
    }
  }, {
    path: 'application-artatech/:id',
    component: ApplicationArtatechDetailComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'deviceConfigurerServiceApp.application.home.title'
    }
  }
];

export const applicationPopupRoute: Routes = [
  {
    path: 'application-artatech-new',
    component: ApplicationArtatechPopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'deviceConfigurerServiceApp.application.home.title'
    },
    outlet: 'popup'
  },
  {
    path: 'application-artatech/:id/edit',
    component: ApplicationArtatechPopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'deviceConfigurerServiceApp.application.home.title'
    },
    outlet: 'popup'
  },
  {
    path: 'application-artatech/:id/delete',
    component: ApplicationArtatechDeletePopupComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'deviceConfigurerServiceApp.application.home.title'
    },
    outlet: 'popup'
  }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/application/application-artatech.route.ts